module.exports = __webpack_public_path__ + "static/media/gift08_en.eb6d10b5.png";